<script>
    import axios from 'axios';
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        props: {
            idFromUrl: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                specificationData: [],
            };
        },
        async mounted() {
            await this.fetchData(this.idFromUrl);
        },
        methods: {
            async fetchData(idFromURL) {
                try {
                    const response = await axios.get(
                        `/api/dossiers/${idFromURL}/specificatie`
                    );
                    if (response ?? response.data) {
                        this.specificationData = response.data;
                    } else {
                        console.error('Invalid data received:', response);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            },
        },
    };
</script>

<template>
    <div class="specification mt-5 content">
        <div class="specification__title">
            <i class="fa-solid fa-sack-dollar"></i>
            <span class="is-size-7">
                {{ $store.getters.getRightText('dossierdetailTitleSpecificationProgressPicture') }}
            </span>

        </div>
        <div class="block is-size-8">
            {{
				$store.getters.getRightText(
					'dossierdetailSubtitleSpecificationToBePaidByCustomer'
				)
            }}
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationPrincipalAmount'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.hoofdsom, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationTermIncreases'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.termijnverhogingenOpd, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationInterest'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.rente, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationCollectionCostsInclVat'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.incassokosten, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationOtherCosts'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.overigeKosten, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationProcessCosts'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.procesKosten, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationExecutionCosts'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.executieKosten, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationPaidToYouBeforeSubmission'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.bijuvoorindiening, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationPaidToYouAfterSubmission'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.bijuNaindiening, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationCompletedAtGgn'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.bijOns, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationBalance'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.totaal, true) }}</p>
            </div>
        </div>
        <div class="block is-size-8">
            {{
				$store.getters.getRightText(
					'dossierdetailSubtitleSpecificationToCollectForYou'
				)
            }}
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationPrincipalAmount'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.hoofdsomOPD, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationTermIncreases'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.termijnverhogingenOpd, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationClientCosts'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>{{ toEuro(specificationData.kostenOpd, true) }}</p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationPaidToYou'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.bijClientOpd, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationInterest'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.renteOpd, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationToCollectForYou'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.voorUTeIncasseren, true) }}
                </p>
            </div>
        </div>
        <div class="block is-size-8">
            {{
				$store.getters.getRightText(
					'dossierdetailSubtitleSpecificationCashFlow'
				)
            }}
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationAdvances'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.verschottenOpd, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{
						$store.getters.getRightText(
							'dossierdetailLabelSpecificationInvoicedInterim'
						)
                    }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.tussentijdsAfgewikkeld, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{ $store.getters.getRightText('dossierdetailLabelSpecificationPaidInTheMeantime') }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.tussentijdsAfgedragen, true) }}
                </p>
            </div>
        </div>
        <div class="columns is-gapless mb-0">
            <div class="column is-two-fifths">
                <p>
                    {{ $store.getters.getRightText('dossierdetailLabelSpecificationReceivedOrPaidByYou') }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.dooruOntvangenOfBetaaldLopend + specificationData.dooruOntvangenOfBetaaldGesloten, true) }}
                </p>
            </div>
        </div>
        <div v-if="specificationData.btwVoordeel" class="columns is-gapless">
            <div class="column is-two-fifths">
                <p>
                    {{ $store.getters.getRightText( 'dossierdetailLabelSpecificationVatBenefit') }}
                </p>
            </div>
            <div class="column is-three-fifths">
                <p>
                    {{ toEuro(specificationData.btwVoordeel, true) }}
                </p>
            </div>
        </div>
    </div>
</template>

